import {createAction, props} from '@ngrx/store';
import type {SlotRenderedEvent} from './ads.model';

export const googletagIsLoaded = createAction(
  '[First DFP Callback] googletag is loaded (available on window)'
);

export const startGlobalAdCycle = createAction(
  'Start Global Ad Cycle',
  props<{ payload: { targetings: { [key: string]: string | string[] } } }>()
);

export const slotRenderEnded = createAction(
  '[Googletag event] Slot has rendered',
  props<{ payload: { adPath: string; event: SlotRenderedEvent } }>()
);

export const thirdpartyadsUpdate = createAction(
  '[Googletag event] Consent Thirdparty updated',
  props<{ payload: { consent: boolean } }>()
);
